module.exports = __webpack_public_path__ + "static/media/close.5ae5eba9.svg";